<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <!-- Shipping Receipient -->
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Shipping To:
      </h3>

      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <p
          v-for="(line, i) in shipmentAddressLines"
          :key="`shipment-${i}`"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ line }}
        </p>
      </div>
    </div>

    <!-- Shipping Method -->
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Shipping Method:
      </h3>

      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <p class="cf-subtitle cf-subtitle--2">
          {{ receipt.shipment.shippingMethodName }}
        </p>

        <p class="cf-subtitle cf-subtitle--2">
          {{ receipt.shipment.shippingMethodDescription }}
        </p>
      </div>
    </div>

    <!-- Shipping Instructions -->
    <template v-if="receipt.shipment.shippingInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Shipping Instructions:
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          {{ receipt.shipment.shippingInstructions }}
        </p>
      </div>
    </template>

    <!-- Additional Info -->
    <template v-if="receipt.pickupInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Additional Info:
        </h3>

        <cf-formatted-content
          class="dark"
          :content="receipt.pickupInstructions"
        />
      </div>
    </template>

    <!-- Gifting Note -->
    <template v-if="receipt.shipment.shippingGiftMessage">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Gift Note:
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          {{ receipt.shipment.shippingGiftMessage }}
        </p>
      </div>
    </template>
  </div>
</template>


<script>
  import { formatAddress } from '@/helpers/address-format';


  export default {
    name: 'ShippingReceiptFulfillmentDetails',

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      receiptShipmentAddress() {
        return this.receipt.shipment.shipToAddress;
      },

      shipmentAddressLines() {
        if (!this.receiptShipmentAddress) return [];
        return formatAddress(this.receiptShipmentAddress, this.receiptShipmentAddress.countryCode);
      }
    }
  };
</script>
